/* eslint-disable no-console */
// Web-safe mock for tealium-react-native
// Provides Tealium analytics functionality for web

const mockTealium = {
  // Initialize Tealium with configuration
  initialize: (config, callback) => {
    console.log('Tealium: Initialized with config', config);
    // Simulate successful initialization
    setTimeout(() => {
      if (callback) callback(true);
    }, 100);
  },

  // Track events
  track: event => {
    if (window.utag?.link) {
      window.utag.link({
        tealium_event: event?.name,
        ...(event?.payload || {}),
      });
    } else {
      console.warn('window.utag not loaded');
    }
  },

  // Set consent status
  setConsentStatus: status => {
    console.log('Tealium: Set consent status', status);
  },

  // Add remote command handler
  addRemoteCommand: (commandId, handler) => {
    console.log('Tealium: Added remote command', commandId);
  },
};

export default mockTealium;
